import { Button, ButtonsGroup, Tooltip } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useDepositInvoiceForm } from '../../contexts/depositInvoiceDetailsFormContext'

type DepositInvoiceDetailsModalFooterProps = {
  onClose: () => void
}

export const DepositInvoiceDetailsModalFooter = ({ onClose }: DepositInvoiceDetailsModalFooterProps) => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { submitForm, isEditMode, depositDetailsForm } = useDepositInvoiceForm()

  const [amount, amountType] = depositDetailsForm.watch(['amount', 'type'])

  const handleSubmitButtonClick = useCallback(() => {
    track('XXX - Invoicing Core - Deposit Modal - Submit button clicked', {
      amount,
      amountType,
    })
    submitForm()
  }, [amount, amountType, submitForm, track])

  return (
    <ButtonsGroup>
      <Button variant="text" onClick={onClose}>
        {t('return')}
      </Button>

      {isEditMode ? (
        <Button onClick={handleSubmitButtonClick}>{t('apply')}</Button>
      ) : (
        <Tooltip label={t('external_invoices.deposit_invoice_details_modal.continue_tooltip')} placement="top">
          <Button onClick={handleSubmitButtonClick}>{t('continue')}</Button>
        </Tooltip>
      )}
    </ButtonsGroup>
  )
}
